import React from 'react';

const Card = ({ children, className }) => {
  if (!children) {
    return null;
  }
  return (
          <div className={`bg-white p-4 shadow-card ${className || ''}`}>
            {children}
          </div>
  );
};

export default Card;
